<template>
    <main>
        <Head>
            <link
                rel="icon"
                href="/images/icon.jpeg"
                type="image/gif"
                sizes="16x16"
            />
            <title>Sultan Fatah - Pendaftaran Online</title>
        </Head>
        <div class="container w-full md:px-56 pt-2">
            <AdminInfo class="mt-2" />
        </div>
        <div class="container md:px-56 pb-10">
            <slot />
            <div class="w-full md:w-1/2 mx-auto">
                <hr class="mt-5" />
                <div class="w-full flex justify-center">
                    <Link 
                        v-if="$page.url != '/auth/login' && $page.url != '/admin'" 
                        @click="back"
                        class="btn-red rounded-3xl mt-2 text-white m-auto w-32 h-14"
                    >
                        Kembali
                    </Link>
                    <Link 
                        v-if="$page.url != '/auth/login'"
                        @click="logout"
                        class="btn-red rounded-3xl mt-2 text-white m-auto w-32 h-14"
                    >
                        LOGOUT
                    </Link>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { Head } from "@inertiajs/inertia-vue3";
import RandomShape from "./RandomShape.vue";
import Contact from "./Contact.vue";
import AdminInfo from "./AdminInfo.vue";

export default {
    components: {
        RandomShape,
        Head,
        Contact,
        AdminInfo,
        Link
    },
    methods: {
        back() {
            window.history.back();
        },
        logout() {
            const confirm = window.confirm("Yakin Anda akan Logout?");
            if (confirm == 1) {
                this.$inertia.post(
                    "/auth/logout",
                    {},
                    {
                        preserveScroll: true,
                        preserveState: true,
                    }
                );
            }
        },
    },
};
</script>
